import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Menu } from '../../models/menu';
import { Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { TegelModule } from '@scania/tegel-angular-17';

import { LocalContextService } from '../../../shared/services/local-context.service';
import { LocalId } from '../../../shared/enums/local.enum';
import { UserService } from '../../services/user.service';
import { GraphService } from '../../../shared/services/graph.service';

@Component({
  selector: 'app-side-menu',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TegelModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent {
  isMenuOpened = false;
  selectedMenu = '';
  photoUrl: string | null = null;
  noPhoto = false;

  menus: Menu[] = [
    new Menu('Home', '', 'home', null),
    new Menu('Filas', 'filas', 'report', [
      new Menu('SLA Segurança', 'filas/sla-seguranca', '', null, [LocalId.SLA]),
      new Menu('SLA Fiscal', 'filas/sla-fiscal', '', null, [LocalId.SLA]),
      new Menu('SLA Diretos', 'filas/sla-diretos', '', null, [LocalId.SLA]),
      new Menu('SLA Indiretos', 'filas/sla-indiretos', '', null, [LocalId.SLA]),
      new Menu('LCB Segurança', 'filas/lcb-seguranca', '', null, [LocalId.LCB]),
      new Menu('LCB Produtivo', 'filas/lcb-produtivo', '', null, [LocalId.LCB]),
      new Menu('LCB Embalagens', 'filas/lcb-embalagem', '', null, [
        LocalId.LCB,
      ]),
    ]),
    new Menu('Painel', 'painel', 'insights', null),
    new Menu('Recebimento', 'recebimentos', 'truck', null),
    new Menu('Totem', 'totem', 'print', null),
    new Menu('Biometria', 'biometria', 'camera', [
      new Menu('Cadastro de motorista', 'biometria/cadastro', '', null),
      new Menu('Identificação', 'biometria/identificacao', '', null),
    ]),
    new Menu('Configurações', 'configuracao', 'settings', [
      new Menu('Fases', 'configuracao/fases', '', null),
      new Menu('Locais', 'configuracao/locais', '', null),
    ]),
  ];

  public currentLocalId: number | null = null;

  constructor(
    private readonly router: Router,
    private readonly menuService: MenuService,
    public localContextService: LocalContextService,
    public userService: UserService,
    private graph: GraphService,
  ) {
    this.menuService.signal$.subscribe((value) => {
      this.mobileMenuAction(value);
    });
    this.menuService.menu$.subscribe((value) => {
      this.menuSelection(value);
    });
    this.localContextService.currentLocalId$.subscribe((novoId) => {
      this.currentLocalId = novoId;
    });
  }

  ngOnInit() {
    void this.getPhoto().catch((err) => {
      console.error('Erro ao carregar a foto no menu lateral', err);
    });
  }

  async getPhoto() {
    try {
      const blob = await this.graph.getUserPhotoBlob();
      this.photoUrl = URL.createObjectURL(blob);
    } catch (err: any) {
      if (err.message === 'No photo') this.noPhoto = true;
      else console.error(err);
    }
  }

  navigate(path: string) {
    this.isMenuOpened = false;
    this.menuService.selectedMenu(path);
    this.router.navigateByUrl(path);
  }

  mobileMenuAction(action: boolean) {
    this.isMenuOpened = action;
  }

  menuSelection(selectedMenu: string) {
    this.selectedMenu = selectedMenu;
  }
}
